export default "__VITE_ASSET__DK55A5AE__"